import React, { useState } from "react";

export default function useErrors(defaultValue = {}) {
  const [errors, setErrors] = useState(defaultValue);

  return { errors, setErrors };
}
